import axios, { AxiosError } from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { AuthenticationAxios } from "../Contracts/Axios";
import { ScoutFeature } from "../Enums/ScoutFeature";
import { intercomBoot, intercomCallbacks } from "../Logic/UserLogic";
import { IFeature, IServiceResult, IUser } from "../Models/Models";
import { getAllUsersFailure, getAllUsersSuccess, getUserFailure, getUserSuccess } from "../View/Products/Actions/UserActions";
import * as types from "./Types";
import { logout } from "../Logic/SessionLogic";

declare let scout;

export const loadUser: ActionCreator<ThunkAction<any, any, any, any>> = () => {
    return (dispatch: Dispatch<any>) => {
        const authenticationAxios = new AuthenticationAxios();
        const promise = authenticationAxios.LoadUser();

        promise
            .then((response: IServiceResult<IUser>) => {
                const user: IUser = response.data;

                // Callbacks will only be set up for SCOUT, while the boot snippet should be applied to every app when loadUser is called
                if((window as any).scout) {
                    intercomCallbacks(user);
                }
                intercomBoot(user);

                dispatch(getUserSuccess(user));
            })
            .catch((error: AxiosError) => {
                dispatch(getUserFailure(error.message));
            });
    };
};

//Thunk Action
export const getAllUsers: ActionCreator<ThunkAction<any, any, any, any>>
  = () => {
      return (dispatch: Dispatch<any>) => {
          axios
              .get("/Users/Listing")
              .then((response) => {
                  const allUsers: IUser[] = response.data.data;
                  dispatch(getAllUsersSuccess(allUsers));
              })
              .catch((error: AxiosError) => {
                  dispatch(getAllUsersFailure(error.message));
              });
      };
  };

export const trackLogin = (): void => {
    const uri = $("#GetCurrentSessionUri").text();

    getSessionID(uri)
        .then((sessionId) => {
            addLoginDate(sessionId);
        });
};

export const getSessionID = (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        const oktaAxios = axios.create({ withCredentials: true });
        oktaAxios
            .get(url)
            .then((response) => {
                resolve(response.data.id || null);
            })
            .catch((error) => {
                // If 404 is returned, that means there are no active sessions for this Okta user and they need to be booted.
                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    logout("/Account/Logout");
                }
                reject();
            });
    });
};

export const addLoginDate = (sessionId: string) => {
    axios
        .post("/Users/AddLoginDate", {
            sessionId: sessionId,
        })
        .catch((error) => {
            console.error(error);
        });
};

export const setShowActiveUsers = (data: boolean) => ({
    type: types.SET_SHOW_ACTIVE_USERS,
    data: data,
});

export const hasFeature = (user: IUser | null, feature: ScoutFeature): boolean => {
    return !user
        ? false
        : user.features?.some((userFeature: IFeature) => userFeature?.name === feature);
};

export const enableTimeoutFeature = () => {
    return scout.logic.FeatureFlagLogic.featureFlags.scoutUserManagementTimeout;
};
